<script>
  import Footer from "@/components/Footer.vue";

  export default {
    name: "AppLegals",
    components: {
      Footer
    },
    mounted() {
      window.addEventListener('keydown', this.handleEscapeKey);
    },
    methods: {
      handleEscapeKey(event) {
        if (event.key === "Escape") {
          this.$router.push('/'); // Redirection vers la page d'accueil
        }
      }
    }
  }
</script>

<template>
  <div id="legals">
    <nav>
      <div class="back-btn">
        <router-link to="/"><img src="@/assets/images/icon/back.svg" alt="back-btn"></router-link>
      </div>
    </nav>

    <h1>Mentions Légales</h1>

    <div class="mb">
      <h2>1. Informations Générales</h2>
      <p><strong>Propriétaire du site :</strong> VERPILLON Numa EI</p>
      <p><strong>Statut juridique :</strong> Micro-entrepreneur</p>
      <p><strong>Numéro SIRET :</strong> 93391999500011</p>
      <p><strong>Adresse :</strong> 27 rue Alphonse Gelibert</p>
      <p><strong>E-mail :</strong> <a href="mailto:numaverpillon42@gmail.com">numaverpillon42@gmail.com</a></p>
      <p><strong>Directeur de la publication :</strong> VERPILLON Numa</p>
    </div>

    <div class="mb">
      <h2>2. Hébergement</h2>
      <p><strong>Hébergeur :</strong> Hostinger</p>
      <p><strong>Adresse de l'hébergeur :</strong> Hostinger International Ltd, 61 Lordou Vironos Street, 6023 Larnaca, Chypre</p>
      <p><strong>Site web de l'hébergeur :</strong> <a href="https://www.hostinger.fr" target="_blank">https://www.hostinger.fr</a></p>
    </div>

    <div class="mb">
      <h2>3. Propriété Intellectuelle</h2>
      <p>L'ensemble des contenus présents sur ce site (textes, images, graphismes, logos, icônes, etc.) sont la propriété exclusive de VERPILLON Numa sauf mention contraire.
        Toute reproduction, modification, distribution ou exploitation, sans autorisation préalable, est strictement interdite.</p>
    </div>

    <div class="mb">
      <h2>4. Responsabilités</h2>
      <p>Le propriétaire du site met tout en œuvre pour assurer l'exactitude et la mise à jour des informations présentes sur ce site.
        Toutefois, il ne peut être tenu responsable des omissions, des inexactitudes ou des carences dans la mise à jour.</p>
    </div>

    <div class="mb">
      <h2>5. Données Personnelles</h2>
      <p>Le site peut collecter certaines données personnelles via des outils analytiques.
        Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès,
        de modification et de suppression de vos données en envoyant une demande à <strong>numaverpillon42@gmail.com</strong>.</p>
    </div>

    <div class="mb">
      <h2>6. Liens Externes</h2>
      <p>Ce site peut contenir des liens vers d'autres sites web.
        Le propriétaire du site ne peut être tenu responsable du contenu de ces sites externes ni de leur politique de confidentialité.</p>
    </div>

    <div class="mb">
      <h2>7. Droit Applicable</h2>
      <p>Les présentes mentions légales sont soumises au droit français.
        En cas de litige, les tribunaux compétents seront ceux de la juridiction du siège social du propriétaire du site.</p>
    </div>

    <div class="mb text-center">
      <p><strong>Date de dernière mise à jour :</strong> 31/01/2025</p>
    </div>
  </div>
  <Footer />
</template>

<style>
  #legals {
    text-align: left;
    margin: 1vh 8vw;
  }

  #legals h1{
    margin-top: 8vh;
    text-transform: uppercase;
    font-size: 3em;
  }

  #legals h2{
    font-size: 2em;
  }

  #legals p{
    font-size: 1.1em;
  }

  #legals strong{
    font-weight: 500;
  }

  .mb{
    margin-bottom: 5vh;
  }

  .text-center{
    text-align: center;
    font-size: 1em;
    padding-top: 0.6vh;
  }
</style>